import { useMemo } from "react";
import ProviderApp from "../../ProviderApp";
import UserNameTagComponentWithProvider, {
  UserNameTagComponentWithProviderProps,
} from "./UserNameTagComponentWithProvided";

/**
 * The tag wrapped in its own providers (it is also mounted into detached grid-cell roots). The provider
 * subtree is memoised on EVERY prop the tag reads: memoising on a subset (`id`, `email`, …) left the others
 * (`fullName`, `size`, `style`, …) stuck at their first value whenever only they changed.
 */
function UserNameTagComponent({
  id,
  handleDeleteIconClicked,
  showAvatarOnly,
  size,
  isCircle,
  isSquare,
  bgColor,
  isExternal,
  style,
  maxAvatars,
  userIdsForGroup,
  fullName,
  email,
  chipBackground,
  chipBorder,
  enableDetailsModalForGroupedUsers,
  detailsModalHeader,
}: UserNameTagComponentWithProviderProps) {
  const provider = useMemo(
    () => (
      <ProviderApp>
        <UserNameTagComponentWithProvider
          id={id}
          handleDeleteIconClicked={handleDeleteIconClicked}
          showAvatarOnly={showAvatarOnly}
          size={size}
          isCircle={isCircle}
          isSquare={isSquare}
          bgColor={bgColor}
          isExternal={isExternal}
          style={style}
          maxAvatars={maxAvatars}
          userIdsForGroup={userIdsForGroup}
          fullName={fullName}
          email={email}
          chipBackground={chipBackground}
          chipBorder={chipBorder}
          enableDetailsModalForGroupedUsers={enableDetailsModalForGroupedUsers}
          detailsModalHeader={detailsModalHeader}
        />
      </ProviderApp>
    ),
    [
      id,
      handleDeleteIconClicked,
      showAvatarOnly,
      size,
      isCircle,
      isSquare,
      bgColor,
      isExternal,
      style,
      maxAvatars,
      userIdsForGroup,
      fullName,
      email,
      chipBackground,
      chipBorder,
      enableDetailsModalForGroupedUsers,
      detailsModalHeader,
    ],
  );

  return provider;
}

export default UserNameTagComponent;
